import AllInOneApiImg from '../assets/AllInOneAPI.webp';
import MyHome from '../assets/MyHome-user-home.webp';

export const projectsData = [
  {
    name: 'All in One API',
    image: AllInOneApiImg,
  },
  {
    name: 'My Home',
    image: MyHome,
  },
]